import axios from "src/libs/axios";
import { safeSessionSetItem } from "./storage";

const fetcher = async ({ url, method = "GET", body = {} }) => {
  const response = await axios({
    method,
    url,
    data: body
  });

  const isImpersonating =
    response.headers["x-impersonate"] ||
    response.headers["x-impersonate"]?.toLowerCase() === "true" ||
    response.headers["x-impersonate"] === true
      ? true
      : false;

  safeSessionSetItem("loginAs", String(isImpersonating));

  return response;
};

export default fetcher;
